import PropTypes from "prop-types"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import GenericNotFound from "app/generic-not-found"
import { setExperiment } from "app-store-v2/app/actions"
import Homepage from "areas/homepage/jewlr"
import Landing from "areas/landing"
import { jewlr_t } from "helpers/application"

import fetchCollection from "./hoc/fetch-collection"
import useCollection from "./hoc/use-collection"
import FullLoading from "./loaders"

import Collection from "./"

const LoadCollection = ({ staticContext }) => {
  const { data, disabled, error } = useCollection()
  const { model } = data || {}
  const loading = useSelector((state) => state.collection.loading)
  const dispatch = useDispatch()
  const promiseRingsExp = useSelector((state) => state.experiment.promiseRings)
  const preBfExp = useSelector((state) => state.experiment.preBf)

  useEffect(() => {
    if (
      promiseRingsExp &&
      (data?.url_path === "promise-rings" ||
        data?.mountedPath === "/promise-rings")
    ) {
      dispatch(
        setExperiment({
          promiseRings: promiseRingsExp,
        })
      )
    }
  }, [data?.url_path, data?.mountedPath, promiseRingsExp])

  useEffect(() => {
    if (
      preBfExp &&
      (data?.url_path ===
        `early-black-friday-${jewlr_t("terms.jewelry")}-sale` ||
        data?.mountedPath ===
          `/early-black-friday-${jewlr_t("terms.jewelry")}-sale`)
    ) {
      dispatch(
        setExperiment({
          preBf: preBfExp,
        })
      )
    }
  }, [data?.url_path, data?.mountedPath, preBfExp])

  if (error || disabled) {
    return <GenericNotFound staticContext={staticContext} />
  } else if (!data || loading === "full") {
    return <FullLoading />
  } else if (model === "landing") {
    return data.url_path === "homepage" ? <Homepage /> : <Landing />
  }

  return <Collection />
}

LoadCollection.propTypes = {
  staticContext: PropTypes.object,
}

export default fetchCollection(LoadCollection)
